import useLabels from "../../hooks/useLabels";
import bio from "../../assets/icons/bio.png";
import vegan from "../../assets/icons/vegan.png";
import "./styles/index.scss";

const LotLabelTag = ({ tag, color, isIcon, isMobile = false }) => {

  const getColor = () => {
    if (tag === 'Bio') return "light_green";
    if (tag === 'Vegan') return "green";
    else return color;
  }

  return (<div className="tag_wrapper">
    <div className={`tag ${getColor()}`}>{tag}
      {tag ==='Bio' && isIcon && <img className="icon" src={bio} alt={'bio'} />}
      {tag === 'Vegan' && isIcon && <img className="icon" src={vegan} alt={'vegan'} />}
    </div>
  </div>)
}

const LotLabelTags = ({ tags = [], color = 'red', isIcon = false, isTitle = false, isDetail = false, isMobile = false }) => {
  const [getLabel] = useLabels();

  return (<div>
    {isTitle && isDetail && <h4>{getLabel("lotLabel")}</h4>}
    {isTitle && !isDetail && <h5>{getLabel("lotLabel")}</h5>}
    <div className="tags_wrapper">
    {tags?.map((tag, index) => {
        return (
          <LotLabelTag key={`label-${index}`} tag={getLabel(`lotLabel_${tag}`)} color={color} isIcon={isIcon} />
        );
      }, "") || ""}
    </div>
  </div>)
}

export default LotLabelTags;
